var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPivot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9 0H2.1A2.106 2.106 0 000 2.1v37.8A2.106 2.106 0 002.1 42h37.8a2.106 2.106 0 002.1-2.1V2.1A2.106 2.106 0 0039.9 0zm-1.05 13.65v6.3h-25.2v-6.3h25.2zm0 15.75h-25.2v-6.3h25.2v6.3zm-35.7-6.3h7.35v6.3H3.15v-6.3zm0-9.45h7.35v6.3H3.15v-6.3zm0 18.9h7.35v6.3H3.15v-6.3zm35.7 6.3h-25.2v-6.3h25.2v6.3z",
    fill: "#515864",
    fillRule: "nonzero"
  })));
}
export default SvgPivot;